"use client";

import { c as _c } from "react/compiler-runtime";
import { FallbackImage } from "@/components/common/FallbackImage";
import { ImageMediaModal, requestCenteredImageFullscreen } from "@/components/drops/view/item/content/media/ImageMediaModal";
import { InlineMediaActions } from "@/components/drops/view/item/content/media/MediaActionToolbar";
import { useMediaActions } from "@/components/drops/view/item/content/media/useMediaActions";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import useCapacitor from "@/hooks/useCapacitor";
import React, { useCallback, useRef, useState } from "react";
function NaturalHeightImage(t0) {
  const $ = _c(17);
  const {
    imgRef,
    primarySrc,
    fallbackSrc,
    retryTick,
    onLoad,
    onFinalError,
    imageObjectPosition
  } = t0;
  const [aspectRatio, setAspectRatio] = useState();
  let t1;
  if ($[0] !== onLoad) {
    t1 = event => {
      const {
        naturalHeight,
        naturalWidth
      } = event.currentTarget;
      if (naturalHeight > 0 && naturalWidth > 0) {
        setAspectRatio(`${naturalWidth} / ${naturalHeight}`);
      }
      onLoad();
    };
    $[0] = onLoad;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLoad = t1;
  let t2;
  if ($[2] !== aspectRatio) {
    t2 = {
      aspectRatio,
      maxHeight: "16rem"
    };
    $[2] = aspectRatio;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== imageObjectPosition) {
    t3 = {
      objectPosition: imageObjectPosition
    };
    $[4] = imageObjectPosition;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== fallbackSrc || $[7] !== handleLoad || $[8] !== imgRef || $[9] !== onFinalError || $[10] !== primarySrc || $[11] !== retryTick || $[12] !== t3) {
    t4 = <FallbackImage key={retryTick} ref={imgRef} primarySrc={primarySrc} fallbackSrc={fallbackSrc} alt="Drop media" fill={true} sizes="(max-width: 768px) 100vw, 768px" optimize={false} className="tw-object-contain" style={t3} onLoad={handleLoad} onError={onFinalError} />;
    $[6] = fallbackSrc;
    $[7] = handleLoad;
    $[8] = imgRef;
    $[9] = onFinalError;
    $[10] = primarySrc;
    $[11] = retryTick;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = <span className="tw-relative tw-block tw-min-h-px tw-w-full tw-max-w-full tw-overflow-hidden" style={t2}>{t4}</span>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export default function WaveDropPartContentMediaImage(t0) {
  const $ = _c(40);
  const {
    src,
    imageScale: t1,
    imageObjectPosition: t2
  } = t0;
  const imageScale = t1 === undefined ? ImageScale.AUTOx450 : t1;
  const imageObjectPosition = t2 === undefined ? "center" : t2;
  const [loaded, setLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const [retryTick, setRetryTick] = useState(0);
  const {
    isCapacitor
  } = useCapacitor();
  const imgRef = useRef(null);
  const modalImageRef = useRef(null);
  let t3;
  if ($[0] !== src) {
    t3 = {
      url: src,
      fallbackFileName: "image",
      dialogTitle: "Save image",
      mimeType: "image"
    };
    $[0] = src;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    downloadMedia,
    isDownloading,
    openLabel,
    openMedia
  } = useMediaActions(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setLoaded(true);
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const handleImageLoad = t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setErrorCount(1);
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleError = t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setLoaded(false);
      setErrorCount(0);
      setRetryTick(_temp);
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const manualRetry = t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => {
      event.stopPropagation();
      setIsModalOpen(true);
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const handleOpenModal = t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsModalOpen(false);
    };
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const handleCloseModal = t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      const fullscreenTarget = modalImageRef.current ?? imgRef.current;
      if (fullscreenTarget) {
        requestCenteredImageFullscreen(fullscreenTarget);
      }
    };
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const handleFullScreen = t9;
  if (errorCount > 0) {
    let t10;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-8"><span className="tw-text-sm tw-text-iron-400">Couldn’t load image.</span><button type="button" onClick={manualRetry} className="tw-rounded-md tw-bg-iron-700 tw-px-3 tw-py-1 tw-text-xs tw-text-white hover:tw-bg-iron-600">Retry</button></div>;
      $[8] = t10;
    } else {
      t10 = $[8];
    }
    return t10;
  }
  const t10 = !isCapacitor;
  let t11;
  if ($[9] !== downloadMedia || $[10] !== isDownloading || $[11] !== openLabel || $[12] !== openMedia || $[13] !== t10) {
    t11 = <InlineMediaActions variant="image" onOpen={openMedia} openLabel={openLabel} onDownload={downloadMedia} isDownloading={isDownloading} onFullscreen={handleFullScreen} fullscreenTargetAvailable={t10} />;
    $[9] = downloadMedia;
    $[10] = isDownloading;
    $[11] = openLabel;
    $[12] = openMedia;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== imageScale || $[16] !== src) {
    t12 = getScaledImageUri(src, imageScale);
    $[15] = imageScale;
    $[16] = src;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== imageObjectPosition || $[19] !== retryTick || $[20] !== src || $[21] !== t12) {
    t13 = <button type="button" onClick={handleOpenModal} aria-label="Open drop media" className="tw-block tw-w-full tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"><NaturalHeightImage key={retryTick} imgRef={imgRef} primarySrc={t12} fallbackSrc={src} retryTick={retryTick} onLoad={handleImageLoad} onFinalError={handleError} imageObjectPosition={imageObjectPosition} /></button>;
    $[18] = imageObjectPosition;
    $[19] = retryTick;
    $[20] = src;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <div className="tw-relative tw-w-full">{t11}{t13}</div>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== loaded) {
    t15 = !loaded && <div className="tw-sr-only" aria-live="polite">Loading image</div>;
    $[26] = loaded;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== downloadMedia || $[29] !== isCapacitor || $[30] !== isDownloading || $[31] !== isModalOpen || $[32] !== openLabel || $[33] !== openMedia || $[34] !== src) {
    t16 = isModalOpen && <ImageMediaModal src={src} imageRef={modalImageRef} onClose={handleCloseModal} onOpen={openMedia} openLabel={openLabel} onDownload={downloadMedia} isDownloading={isDownloading} onFullscreen={handleFullScreen} fullscreenTargetAvailable={!isCapacitor} />;
    $[28] = downloadMedia;
    $[29] = isCapacitor;
    $[30] = isDownloading;
    $[31] = isModalOpen;
    $[32] = openLabel;
    $[33] = openMedia;
    $[34] = src;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t15 || $[38] !== t16) {
    t17 = <>{t14}{t15}{t16}</>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
}
function _temp(currentTick) {
  return currentTick + 1;
}